import type {ReactElement} from 'react';
import React from 'react';
import {BaseFillColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-fill-color-panel';
import type {ColorFillPropertyType} from '@Components/color-fill';
import type {RGBA} from '@Utils/color.util';
import {getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {getFillTypeFromColorFillType} from '@Utils/color.util';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {FillObject, FillTypes} from '@PosterWhiteboard/classes/fill.class';

interface BaseBackgroundColorPanelProps {
  backgroundFillObject: FillObject;
  onChangeType(newType: FillTypes): void;
  onChangeColor(fillColor: RGBA[], undoable?: boolean): void;
}

export function BaseBackgroundColorPanel({...props}: BaseBackgroundColorPanelProps): ReactElement {
  const onChangeType = (newType: ColorFillPropertyType): void => {
    props.onChangeType(getFillTypeFromColorFillType(newType));
  };

  const onChangeColorFillColor = (updatedColor: ColorStorage[]): void => {
    props.onChangeColor(getRGBAArrayFromColorStorage(updatedColor), false);
  };
  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    props.onChangeColor(getRGBAArrayFromColorStorage(updatedColor), true);
  };
  return <BaseFillColorPanel colorObject={props.backgroundFillObject} onChangeColor={onChangeColorFillColor} onChangeType={onChangeType} onChangeColorEnded={onChangeColorEnded} />;
}
